var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackButton)?_c('div',{ref:"menu",class:{ 'organism-menu-bar-embed-project': true, scrolled: _vm.isScrolled },attrs:{"id":"header-project"}},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col",class:{
        'col-xs-4 col-4': _vm.showProjectSelect,
        'col-xs-8 col-4': _vm.showBackButton
      }},[_c('div',{staticClass:"block-element"},[_c('div',{staticClass:"inline-elements"},[_c('NuxtLink',{staticClass:"back-link",attrs:{"tag":"a","to":{
              path: `/embed/${_vm.isEmbedV2 ? 'v2/' : ''}${_vm.activeProject}`
            }}},[_c('AtomsCommonAtomIcon',{attrs:{"icon":"angle-left","size":32,"color":"#000"}})],1)],1)])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }